import { ACCOUNT_CATEGORY, ACCOUNT_TYPE } from "@toruslabs/base-controllers";

export const ACCOUNT_ABSTRACTION_TYPES = [ACCOUNT_CATEGORY.ACCOUNT_ABSTRACTION, ACCOUNT_CATEGORY.SFA_ACCOUNT_ABSTRACTION] as ACCOUNT_TYPE[];

export const SOLANA_WALLET_DAPP_NAME = "Solana Torus Wallet (solana.tor.us)";
